import React from "react";
import { PAGE_KINDS, REASONS, roleLabel } from "./cleanStartLabels";

function Pill({ keep }) {
  return (
    <span className={`text-[10px] font-bold uppercase tracking-widest px-1.5 py-0.5 border ${keep ? "border-emerald-700 bg-emerald-50 text-emerald-800" : "border-rose-700 bg-rose-50 text-rose-800"}`}>
      {keep ? "Keep" : "Remove"}
    </span>
  );
}

function Section({ title, rows, testId, render }) {
  const kept = rows.filter((r) => r.keep).length;
  return (
    <details className="border border-black" data-testid={testId} open={rows.length <= 12}>
      <summary className="cursor-pointer p-2 text-xs font-bold uppercase tracking-widest bg-zinc-50">
        {title} <span className="font-mono normal-case text-zinc-600">· keep {kept} · remove {rows.length - kept}</span>
      </summary>
      <div className="max-h-56 overflow-y-auto divide-y divide-zinc-200">
        {rows.map(render)}
        {!rows.length && <div className="p-2 text-xs text-zinc-500">None</div>}
      </div>
    </details>
  );
}

export function PeopleList({ users }) {
  const rows = [...users].sort((a, b) => Number(b.keep) - Number(a.keep));
  return (
    <Section title="Logins" rows={rows} testId="clean-start-users" render={(u) => (
      <div key={u.id} className="flex items-center justify-between gap-2 p-2 text-xs" data-testid={`clean-start-user-${u.id}`}>
        <div className="min-w-0">
          <div className="font-mono truncate">{u.email}</div>
          <div className="text-zinc-500 capitalize">{roleLabel(u.role)}{u.reason ? ` · ${REASONS[u.reason]}` : ""}</div>
        </div>
        <Pill keep={u.keep} />
      </div>
    )} />
  );
}

export function CompanyList({ orgs }) {
  const rows = [...orgs].sort((a, b) => Number(b.keep) - Number(a.keep));
  return (
    <Section title="Companies" rows={rows} testId="clean-start-orgs" render={(o) => (
      <div key={o.id} className="flex items-center justify-between gap-2 p-2 text-xs" data-testid={`clean-start-org-${o.id}`}>
        <div className="min-w-0">
          <div className="font-bold truncate">{o.name}</div>
          <div className="text-zinc-500 capitalize">{o.type === "client" ? "buyer" : o.type}{o.reason ? ` · ${REASONS[o.reason]}` : ""}</div>
        </div>
        <Pill keep={o.keep} />
      </div>
    )} />
  );
}

export function PageList({ pages, extraKeep, onToggle }) {
  const rows = [...pages].sort((a, b) => Number(b.keep) - Number(a.keep));
  return (
    <>
    <div className="text-[11px] text-zinc-600" data-testid="clean-start-pages-hint">
      Tick a buyer page to keep it. Its buyer company and delivery settings are kept with it; the buyer&apos;s logins are still removed.
    </div>
    <Section title="Landing pages" rows={rows} testId="clean-start-pages" render={(p) => (
      <label key={p.id} className="flex items-center justify-between gap-2 p-2 text-xs cursor-pointer" data-testid={`clean-start-page-${p.slug}`}>
        <span className="flex items-center gap-2 min-w-0">
          <input type="checkbox" className="w-4 h-4" checked={p.keep} disabled={p.default_keep}
            onChange={() => onToggle(p.id)} data-testid={`clean-start-page-keep-${p.slug}`} />
          <span className="min-w-0">
            <span className="font-mono block truncate">/lp/{p.slug}</span>
            <span className="text-zinc-500">{PAGE_KINDS[p.kind]}{p.status ? ` · ${p.status}` : ""}{extraKeep.includes(p.id) ? " · kept by you" : ""}</span>
          </span>
        </span>
        <Pill keep={p.keep} />
      </label>
    )} />
    </>
  );
}
